module.exports = __webpack_public_path__ + "static/img/storage02.f1b4f07c.png";